import NetInfo from '@react-native-community/netinfo'
import { UserServices } from '../../database/user.database'
import { ErrorServices } from '../../database/errors.database'

export interface Ierror {
    log?: string
    date?: string
    end?: string
    additional?: string
}

export const captureAndSaveDataError = async (dataError: Ierror) => {
    const { additional, date, end, log } = dataError
    const netInfoDate = await NetInfo.fetch()
    const user = await UserServices.getUser()
    const dataRegister = {
        user_id: user._id,
        log,
        date,
        connect_status: JSON.stringify(netInfoDate),
        endpoint: end,
        additional,
    }
    await ErrorServices.addErrorLog(dataRegister)
}